export const CATEGORY_ID_PLACEHOLDER = '${categoryId}';
export const TEST_RIDE_CLP_TEST_ID = 'test-ride_clp';
export const TEST_RIDE_PLP_TEST_ID = 'test-ride_plp';
export const IN_RIVER_ID_TEST_RIDE = 'inRiverId';
export const SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED = 'variants.attributes.productABBProductNameLocalized';
export const SORT_PRODUCT_ASC = 'asc';
